import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { TicketActions, SuperAdminAction } from "../../Actions";
import CustomContentAlert from "../helper";
import moment from "moment";
import adminDispute from "../../../assets/img/admin-dispute.svg";
import driverDispute from "../../../assets/img/driver-dispute.svg";
import cancelTicket from "../../../assets/img/svg/ticket-update-icons/cancel-ticket.svg";
import closeDispute from "../../../assets/img/svg/ticket-update-icons/close-dispute.svg";
import paidCash from "../../../assets/img/svg/ticket-update-icons/paid-cash.svg";
import paidCheck from "../../../assets/img/svg/ticket-update-icons/paid-check.svg";
import paidCreditcard from "../../../assets/img/svg/ticket-update-icons/paid-creditcard.svg";
import paidInterac from "../../../assets/img/svg/ticket-update-icons/paid-interac.svg";
import reduceAmount from "../../../assets/img/svg/ticket-update-icons/reduce-amount.svg";
import { Translation } from "react-i18next";
import _i18n from "../../../i18n";
import { allStates } from "../statesData";
const momentTimeZone = require("moment-timezone");
class Dispute extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
      message: "",
      messageList: [],
      show_alert: false,
      api_success_message: "",
      ticket_status: "",
      reduce_amount: "",
      amount: "",
      isValidStatusUpdateForm: false,
      ticketId: "",
      chargable_fee: 0,
      isDriver: false,
      created_at: "",
      isSendTextDisabled: false,
      paidCashDisabled: true,
      paidCardDisabled: true,
      paidCheckDisabled: true,
      paidInteracDisabled: true,
      reduceAmountDisabled: true,
      amountDisabled: true,
      notes_internal: "",
      notes_external: "",
      photos: [],
      costErrorMessage: "",
      amountErrorMessage: "",
      zone: "",
    };
  }

  async componentDidMount() {
    const redirect_from =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.redirect_from
        ? this.props.location.state.redirect_from
        : "";
    const isDriver = !!(redirect_from === "ticket-payment");
    const ticketId =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.ticketId
        ? this.props.location.state.ticketId
        : this.props.location?.search?.split("?")[1];
    if (!isDriver) {
      const selectedPropertyName =
        this.props.property && this.props.property.property_name
          ? this.props.property.property_name
          : "";
      const selectedDomainName =
        this.props.property && this.props.property.domain
          ? this.props.property.domain
          : "";
      this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
    }

    let ticketDetails = "";
    await this.props.getMessageList(ticketId, isDriver, true);
    let driverMessageList;
    if (this.props.api_response) {
      driverMessageList = this.props.driverMessageList;
      driverMessageList.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
      const reversedDriverMessageList = driverMessageList.reverse();
      if (driverMessageList && driverMessageList.length) {
        this.setState({
          messageList: reversedDriverMessageList,
        });
      }
      ticketDetails =
        this.props.ticketDetails && this.props.ticketDetails.data
          ? this.props.ticketDetails.data[0]
          : {};
    }
    const notes_internal =
      ticketDetails && ticketDetails.notes_internal
        ? ticketDetails.notes_internal
        : "-";
    const notes_external =
      ticketDetails && ticketDetails.notes_internal
        ? ticketDetails.notes_internal
        : "-";

    const violationsArray =
      ticketDetails &&
      ticketDetails.reasons &&
      ticketDetails.reasons.length &&
      ticketDetails?.reasons.map((item) => item.title);
    const violations =
      violationsArray && violationsArray.length && violationsArray.join(", ");

    const createdAt = ticketDetails?.created_at
      ? momentTimeZone
          .tz(ticketDetails.created_at, "UTC")
          .tz(ticketDetails.property.timezone)
          .format("lll")
      : "-";
    const updateStatusPermisstion = ticketDetails.dispute_info
      ? ticketDetails.dispute_info
      : false;
    const zone =
      ticketDetails?.property?.domain || ticketDetails?.property?.subdomain;
    let stateAbbreviation = "";
    const filteredState = allStates.filter(
      (item) => item.value === ticketDetails.state_name
    );
    if (filteredState && filteredState.length) {
      stateAbbreviation = filteredState[0].label;
    } else {
      stateAbbreviation = ticketDetails.state_name;
    }
    const plate = `${ticketDetails.lpn} ${ticketDetails.country_name || ""} ${
      stateAbbreviation || ""
    }`;

    this.setState({
      ticketId: ticketId,
      lpn: ticketDetails.lpn ? plate : "-",
      plate_number: ticketDetails.lpn ? ticketDetails.lpn : "-",
      chargable_fee: ticketDetails?.fee ? ticketDetails.fee : 0,
      notes_internal: notes_internal,
      notes_external: notes_external,
      redirect_from: redirect_from,
      isDriver: isDriver,
      created_at: createdAt,
      ticket_no: ticketDetails ? ticketDetails.ticket_no : "-",
      status: ticketDetails ? ticketDetails.status : "-",
      state: ticketDetails ? ticketDetails.state : "-",
      address: ticketDetails.property ? ticketDetails.property.address : "-",
      violations: violations,
      enfocer: ticketDetails.user ? ticketDetails.user.last_name : "-",
      car_model: ticketDetails.car_model ? ticketDetails.car_model : "-",
      car_make: ticketDetails.car_make ? ticketDetails.car_make : "-",
      car_color: ticketDetails.car_color ? ticketDetails.car_color : "-",
      VIN: ticketDetails.vin ? ticketDetails.vin : "-",
      photos: ticketDetails.ticket_photos ? ticketDetails.ticket_photos : [],
      ticketData: ticketDetails,
      updateStatusPermisstion: updateStatusPermisstion,
      zone: zone,
    });
    await this.props.selectedLanguage();
    _i18n.changeLanguage(ticketDetails?.language);
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleRedirectTicketList = () => {
    const history = require("../../history").default;
    history.push({
      pathname: "/citation-list",
      state: {
        plate: this.state.plate_number,
      },
    });
  };

  handleChange = (event) => {
    this.setState(
      {
        message: event.target.value,
      },
      () => {
        if (this.state.message && this.state.message.length) {
          this.setState({
            isSendTextDisabled: true,
          });
        } else {
          this.setState({
            isSendTextDisabled: false,
          });
        }
      }
    );
  };

  handleUpdateChange = (event) => {
    const status = event.target.value;
    this.setState(
      {
        ticket_status: status,
        selectStatus: event.target.value,
      },
      () => {
        if (this.state.selectStatus === "Paid Cash") {
          this.setState({
            reduce_amount: "",
            amount: "",
            paid_check: "",
            paid_creditcard: "",
            paid_interac: "",
            reduceAmountDisabled: true,
            paidCashDisabled: false,
            paidCheckDisabled: true,
            paidInteracDisabled: true,
            paidCardDisabled: true,
            amountDisabled: false,
          });
          if (!this.state.paid_cash) {
            this.setState({
              isValidStatusUpdateForm: false,
            });
          }
        } else if (this.state.selectStatus === "Paid Check") {
          this.setState({
            reduce_amount: "",
            amount: "",
            paid_cash: "",
            paid_creditcard: "",
            paid_interac: "",
            reduceAmountDisabled: true,
            paidCashDisabled: true,
            paidCheckDisabled: false,
            paidInteracDisabled: true,
            paidCardDisabled: true,
            amountDisabled: false,
          });
          if (!this.state.paid_check) {
            this.setState({
              isValidStatusUpdateForm: false,
            });
          }
        } else if (this.state.selectStatus === "Paid Credit Card Manually") {
          this.setState({
            reduce_amount: "",
            amount: "",
            paid_cash: "",
            paid_check: "",
            paid_interac: "",
            reduceAmountDisabled: true,
            paidCashDisabled: true,
            paidCheckDisabled: true,
            paidInteracDisabled: true,
            paidCardDisabled: false,
            amountDisabled: false,
          });
          if (!this.state.paid_creditcard) {
            this.setState({
              isValidStatusUpdateForm: false,
            });
          }
        } else if (this.state.selectStatus === "Paid Interac") {
          this.setState({
            reduce_amount: "",
            paid_cash: "",
            paid_check: "",
            paid_creditcard: "",
            amount: "",
            reduceAmountDisabled: true,
            paidCashDisabled: true,
            paidCheckDisabled: true,
            paidInteracDisabled: false,
            paidCardDisabled: true,
            amountDisabled: false,
          });
          if (!this.state.paid_interac) {
            this.setState({
              isValidStatusUpdateForm: false,
            });
          }
        } else if (this.state.selectStatus === "Reduce_Amount") {
          this.setState({
            paid_cash: "",
            paid_check: "",
            paid_creditcard: "",
            paid_interac: "",
            amount: "",
            reduceAmountDisabled: false,
            paidCashDisabled: true,
            paidCheckDisabled: true,
            paidInteracDisabled: true,
            paidCardDisabled: true,
            amountDisabled: true,
          });
          if (!this.state.reduce_amount) {
            this.setState({
              isValidStatusUpdateForm: false,
            });
          }
        } else {
          this.setState({
            isValidStatusUpdateForm: true,
            reduceAmountDisabled: true,
            paidCashDisabled: true,
            paidCheckDisabled: true,
            paidInteracDisabled: true,
            paidCardDisabled: true,
            amountDisabled: false,
            reduce_amount: "",
            amount: "",
            paid_cash: "",
            paid_check: "",
            paid_creditcard: "",
            paid_interac: "",
          });
        }
      }
    );
  };

  handleRemarkChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, async () => {
      const { ticket_status, reduce_amount } = this.state;
      if (ticket_status === "Reduce_Amount") {
        if (reduce_amount) {
          this.setState({
            isValidStatusUpdateForm: true,
            costErrorMessage: "",
          });
          if (reduce_amount <= 0) {
            this.setState({
              costErrorMessage: "Cost cann't be less than 1",
              isValidStatusUpdateForm: false,
            });
          }
        } else {
          this.setState({
            isValidStatusUpdateForm: false,
          });
        }
      } else {
        this.setState({
          isValidStatusUpdateForm: true,
        });
      }
    });
  };

  handleSendText = async () => {
    const { message, ticketId, isDriver, ticket_no } = this.state;
    const messageObjectToBeSent = {
      ticket_id: ticketId,
      message: message,
      ticket_no: ticket_no,
    };
    await this.props.sendText(messageObjectToBeSent, isDriver);
    if (this.props.api_response) {
      const messageList = this.state.messageList;
      messageList.push(this.props.driverMessage);
      this.setState({
        show_alert: this.props.api_response,
        api_success_message: this.props.api_success_message,
        message: "",
        messageList: messageList,
        isSendTextDisabled: false,
      });
      setTimeout(
        () =>
          this.setState({
            show_alert: false,
          }),
        4000
      );
    }
  };

  handleUpdatedata = async () => {
    const {
      selectStatus,
      ticketId,
      reduce_amount,
      paid_cash,
      paid_check,
      paid_creditcard,
      paid_interac,
      amount,
    } = this.state;
    const updateData = {
      status: selectStatus,
      ticket_id: ticketId,
    };
    if (selectStatus === "Paid Cash") {
      updateData.remark = paid_cash;
    } else if (selectStatus === "Paid Check") {
      updateData.remark = paid_check;
    } else if (selectStatus === "Paid Credit Card Manually") {
      updateData.remark = paid_creditcard;
    } else if (selectStatus === "Paid Interac") {
      updateData.remark = paid_interac;
    } else if (selectStatus === "Reduce_Amount") {
      updateData.remark = reduce_amount;
    }
    updateData.amount = amount;
    await this.props.ticketDisputeStatusChange(updateData);
    if (this.props.api_response) {
      this.setState(
        {
          show_alert: true,
          api_success_message: this.props.api_success_message,
          isValidStatusUpdateForm: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ show_alert: true });
          }, 500);
          const history = require("../../history").default;
          history.push({
            pathname: "/citation-list",
          });
        }
      );
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
    }
  };

  handleBackAction = () => {
    const history = require("../../history").default;
    history.push({
      pathname: "/citation-list",
    });
  };

  handleShowTicketDetails = async () => {
    this.setState({ show: true });
  };

  render() {
    const {
      show,
      message,
      messageList,
      show_alert,
      api_success_message,
      ticket_status,
      isValidStatusUpdateForm,
      reduce_amount,
      amountDisabled,
      amount,
      chargable_fee,
      notes_external,
      created_at,
      ticket_no,
      address,
      status,
      violations,
      lpn,
      enfocer,
      car_model,
      car_make,
      car_color,
      VIN,
      state,
      isSendTextDisabled,
      reduceAmountDisabled,
      paidCardDisabled,
      paidCashDisabled,
      paidCheckDisabled,
      paidInteracDisabled,
      photos,
      paid_cash,
      paid_check,
      paid_creditcard,
      paid_interac,
      zone,
    } = this.state;
    return (
      <div style={{ flex: 1 }}>
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <div className="d-flex">
                    <i
                      className="fa fa-arrow-left mt-1 mr-2 Pointer"
                      aria-hidden="true"
                      onClick={this.handleBackAction}
                    ></i>{" "}
                    Dispute
                    <h4 className="card-title"></h4>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <div className="table-responsive overflow-auto">
                        <Table className="table table-bordered table-striped table-hover fs-14 citation-table">
                          <thead>
                            <tr>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Date")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Plate")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => (
                                    <p className="text-nowrap">
                                      {t("CitationNo")}
                                    </p>
                                  )}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Enforcer")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Address")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Violation")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Fee")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Note")}</p>}
                                </Translation>
                              </th>
                              <th>
                                {" "}
                                <Translation>
                                  {(t) => <p>{t("Status")}</p>}
                                </Translation>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="text-nowrap">{created_at}</td>
                              <td>{lpn}</td>
                              <td>
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    cursor: "pointer",
                                    color: "#303b93",
                                  }}
                                  onClick={() => this.handleShowTicketDetails()}
                                >
                                  <span className="icon-tickit2 fs-20px mr-1"></span>
                                  {ticket_no}
                                </div>
                              </td>
                              <td>{enfocer}</td>
                              <td>{address}</td>
                              <td>{violations}</td>
                              <td>${chargable_fee}</td>
                              <td>{notes_external}</td>
                              <td className="text-nowrap">{status}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col lg="6">
                      <div className="chat-section">
                        <div>
                          <div className="text-right chatbox ">
                            <PerfectScrollbar className="chat-msg-scroll">
                              {messageList && messageList.length
                                ? messageList.map((item, index) => {
                                    return (
                                      <div
                                        className={
                                          item.role === "Support"
                                            ? "d-flex justify-content-end mb-3"
                                            : "d-flex justify-content-start mb-3"
                                        }
                                        key={index}
                                      >
                                        <div
                                          className={
                                            item.role === "Support"
                                              ? "d-flex justify-content-end flex-column"
                                              : "d-flex justify-content-start flex-column text-left"
                                          }
                                        >
                                          <div className="chat-msg">
                                            {item.message}
                                          </div>
                                          <div
                                            className={
                                              "d-flex justify-content-center align-items-center"
                                            }
                                          >
                                            <div className="fs-12px mr-2 mt-1">
                                              {moment(item.created_at).format(
                                                "lll"
                                              )}
                                            </div>
                                            {item.role === "Driver" ? (
                                              <div className="text-right">
                                                <img
                                                  src={driverDispute}
                                                  width={12}
                                                />
                                              </div>
                                            ) : (
                                              <div className="text-right">
                                                <img
                                                  src={adminDispute}
                                                  width={12}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                : null}
                            </PerfectScrollbar>
                          </div>
                        </div>

                        <div className="mt-3">
                          <div className="position-relative">
                            <Translation>
                              {(t) => (
                                <Form.Control
                                  as="textarea"
                                  rows="1"
                                  type="text"
                                  placeholder={t("EnterMessage")}
                                  name="message"
                                  className="chattypearea border"
                                  value={message}
                                  onChange={this.handleChange}
                                />
                              )}
                            </Translation>

                            <Button
                              variant="primary"
                              type="button"
                              className="mr-3 c-pointer send-msg"
                              disabled={!isSendTextDisabled}
                              onClick={this.handleSendText}
                            >
                              <i
                                className="fa fa-paper-plane"
                                aria-hidden="true"
                              ></i>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg="6">
                      <Button
                        variant="primary"
                        type="button"
                        onClick={() => this.handleRedirectTicketList()}
                      >
                        View ticket history for this plate
                      </Button>

                      <div className="border rounded mt-4">
                        <h4 className="mt-0 p-3 mb-0 pb-0">
                          <div as="h4" className="m-0">
                            Update
                          </div>
                        </h4>
                        <Form className="upfate-form">
                          <div className="px-3">
                            <Row>
                              <Col>
                                <div className="d-flex mb-1">
                                  <img
                                    src={cancelTicket}
                                    width="14"
                                    className="mr-2 tiketupdate-icon"
                                  />
                                  <Form.Check
                                    inline
                                    label="Cancel Ticket"
                                    name="Close_Ticket"
                                    type="radio"
                                    value="Close_Ticket"
                                    id="1"
                                    checked={ticket_status === "Close_Ticket"}
                                    onChange={(e) => {
                                      this.handleUpdateChange(e);
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <img
                                  src={reduceAmount}
                                  width="14"
                                  className="mr-2 tiketupdate-icon"
                                />
                                <Form.Check
                                  inline
                                  label="Reduce Ticket"
                                  name="Reduce_Amount"
                                  type="radio"
                                  value="Reduce_Amount"
                                  id="2"
                                  checked={ticket_status === "Reduce_Amount"}
                                  onChange={(e) => {
                                    this.handleUpdateChange(e);
                                  }}
                                />{" "}
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="number"
                                  placeholder="Reduce to: ex: 10"
                                  className="form-control form-control-sm w-150px form-control-sm ml-3"
                                  name="reduce_amount"
                                  value={reduce_amount}
                                  disabled={reduceAmountDisabled}
                                  min={1}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                ></input>
                                <span className="help-block">
                                  {this.state.costErrorMessage}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div className="d-flex mb-1">
                                  <img
                                    src={closeDispute}
                                    width="14"
                                    className="mr-2 tiketupdate-icon ticket-round-icon"
                                  />
                                  <Form.Check
                                    inline
                                    label="Reject Dispute - Driver must pay full"
                                    name="Close_Dispute"
                                    type="radio"
                                    value="Close_Dispute"
                                    id="3"
                                    checked={ticket_status === "Close_Dispute"}
                                    onChange={(e) => {
                                      this.handleUpdateChange(e);
                                    }}
                                  />{" "}
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div className="d-flex mb-1">
                                  <img
                                    src={closeDispute}
                                    width="14"
                                    className="mr-2 tiketupdate-icon ticket-round-icon"
                                  />
                                  <Form.Check
                                    inline
                                    label="Reject Dispute - Driver must pay full. Lock disputes"
                                    name="Close_Dispute_Lock"
                                    type="radio"
                                    value="Close_Dispute_Lock"
                                    id="4"
                                    checked={
                                      ticket_status === "Close_Dispute_Lock"
                                    }
                                    onChange={(e) => {
                                      this.handleUpdateChange(e);
                                    }}
                                  />{" "}
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <div className="px-3 bg-light-gray">
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <img
                                  src={paidCash}
                                  width="18"
                                  className="mr-2 tiketupdate-icon"
                                />
                                <Form.Check
                                  inline
                                  label="Paid - Cash :"
                                  name="paid_cash"
                                  type="radio"
                                  value="Paid Cash"
                                  id="5"
                                  checked={ticket_status === "Paid Cash"}
                                  onChange={(e) => {
                                    this.handleUpdateChange(e);
                                  }}
                                />
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="text"
                                  name="paid_cash"
                                  className="form-control w-150px form-control-sm"
                                  value={paid_cash}
                                  disabled={paidCashDisabled}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                  placeholder="Notes"
                                ></input>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <img
                                  src={paidInterac}
                                  width="14"
                                  className="mr-2 tiketupdate-icon"
                                />
                                <Form.Check
                                  inline
                                  label="Paid - Interac :"
                                  name="paid_interac"
                                  type="radio"
                                  value="Paid Interac"
                                  id="6"
                                  checked={ticket_status === "Paid Interac"}
                                  onChange={(e) => {
                                    this.handleUpdateChange(e);
                                  }}
                                />
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="text"
                                  name="paid_interac"
                                  className="form-control w-150px form-control-sm"
                                  value={paid_interac}
                                  disabled={paidInteracDisabled}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                  placeholder="Notes"
                                ></input>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <img
                                  src={paidCreditcard}
                                  width="14"
                                  className="mr-2 tiketupdate-icon"
                                />
                                <Form.Check
                                  inline
                                  label="Paid - Credit Card Manually :"
                                  name="paid_creditcard"
                                  className="mr-0"
                                  type="radio"
                                  id="7"
                                  value="Paid Credit Card Manually"
                                  checked={
                                    ticket_status ===
                                    "Paid Credit Card Manually"
                                  }
                                  onChange={(e) => {
                                    this.handleUpdateChange(e);
                                  }}
                                />
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="text"
                                  name="paid_creditcard"
                                  className="form-control w-150px form-control-sm"
                                  value={paid_creditcard}
                                  disabled={paidCardDisabled}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                  placeholder="Notes"
                                ></input>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <img
                                  src={paidCheck}
                                  width="14"
                                  className="mr-2 tiketupdate-icon"
                                />
                                <Form.Check
                                  inline
                                  label="Paid - Check :"
                                  name="paid_check"
                                  type="radio"
                                  id="8"
                                  value="Paid Check"
                                  checked={ticket_status === "Paid Check"}
                                  onChange={(e) => {
                                    this.handleUpdateChange(e);
                                  }}
                                />
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="text"
                                  name="paid_check"
                                  className="form-control w-150px form-control-sm"
                                  value={paid_check}
                                  disabled={paidCheckDisabled}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                  placeholder="Notes"
                                ></input>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex align-items-center col-sm">
                                <label className="pl-0 pl-md-5">Amount: </label>
                              </Col>
                              <Col className="col-auto">
                                <input
                                  type="number"
                                  placeholder="Amount"
                                  className="form-control w-150px form-control-sm"
                                  name="amount"
                                  value={amount}
                                  disabled={amountDisabled}
                                  min={0}
                                  onChange={(e) => {
                                    this.handleRemarkChange(e);
                                  }}
                                ></input>
                                <span className="help-block">
                                  {this.state.amountErrorMessage}
                                </span>
                              </Col>
                            </Row>
                          </div>
                          <div className="d-flex justify-content-end pt-2 pb-2 pr-3">
                            <Button
                              id="ignoreButton3"
                              className="btn-fill"
                              type="button"
                              variant="info"
                              size="sm"
                              disabled={!isValidStatusUpdateForm}
                              onClick={this.handleUpdatedata}
                            >
                              Submit
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                  <div></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* ======================MODAL HISTORY================================ */}
          <Modal
            id="ticketDetails"
            lg={"medium"}
            show={show}
            onHide={this.handleClose}
            dialogClassName="modal-90w"
            fullscreen={"sm-down"}
            className="modalData"
          >
            <Modal.Header
              id="ignoreHeader"
              className="d-flex justify-content-between bg-white align-items-center"
            >
              <h4 className="m-0 font-weight-bold">
                <Modal.Title as="h4" className="m-0">
                  <Translation>
                    {(t) => <p>{t("TicketDetails")}</p>}
                  </Translation>
                </Modal.Title>
              </h4>
              <Button
                id="ignoreButton"
                title={"Deactivate"}
                type="button"
                onClick={this.handleClose}
                className="close-btn py-0"
                data-dismiss="modal"
              >
                <i className="nc-icon nc-simple-remove text-danger"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              {" "}
              <Table className="table table-bordered table-striped table-hover tickit-details-table">
                <thead></thead>
                <tbody>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("CitationNo")}</>}</Translation>
                    </th>
                    <td>{ticket_no}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Date")}</>}</Translation>
                    </th>
                    <td>{created_at}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Plate")}</>}</Translation>
                    </th>
                    <td>{lpn}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("VIN")}</>}</Translation>
                    </th>
                    <td>{VIN}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("CarMake")}</>}</Translation>
                    </th>
                    <td>{car_make}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("CarModal")}</>}</Translation>
                    </th>
                    <td>{car_model}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("CarColor")}</>}</Translation>
                    </th>
                    <td>{car_color}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Enforcer")}</>}</Translation>
                    </th>
                    <td>{enfocer}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Address")}</>}</Translation>
                    </th>
                    <td>{address}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Zone")}</>}</Translation>
                    </th>
                    <td>{zone}</td>
                  </tr>
                  <tr>
                    <th className="mb-0">
                      {" "}
                      <Translation>
                        {(t) => <>{t("Violation")}</>}
                      </Translation>{" "}
                    </th>
                    <td>
                      {this.state.ticketData?.reasons &&
                        this.state.ticketData?.reasons.length &&
                        this.state.ticketData?.reasons.map((el, index) => {
                          return (
                            <div key={index}>
                              {el?.title} <br />
                              {el?.reason_costs &&
                                el?.reason_costs.length &&
                                el?.reason_costs.map((reason_cost, key) => {
                                  return el.reason_costs.length === 1 &&
                                    (reason_cost?.period_in_days === 0 ||
                                      reason_cost?.period_in_days === null) ? (
                                    <>
                                      <label key={key} className="mb-0">
                                        Fee: {"$" + reason_cost?.cost}
                                      </label>{" "}
                                      <br />{" "}
                                    </>
                                  ) : key !== 0 &&
                                    (reason_cost?.period_in_days === 0 ||
                                      reason_cost?.period_in_days === null) ? (
                                    <>
                                      <label key={key} className="mb-0">
                                        {"$" +
                                          reason_cost?.cost +
                                          " paid after " +
                                          el?.reason_costs[key - 1]
                                            ?.period_in_days}{" "}
                                        days
                                      </label>{" "}
                                      <br />{" "}
                                    </>
                                  ) : (
                                    <>
                                      <label key={key} className="mb-0">
                                        {key === 0 ? "Fee: " : ""}{" "}
                                        {"$" + reason_cost?.cost} paid{" "}
                                        {reason_cost?.period_in_days
                                          ? "in " + reason_cost?.period_in_days
                                          : "after " +
                                            reason_cost?.period_in_days}{" "}
                                        days
                                      </label>{" "}
                                      <br />
                                    </>
                                  );
                                })}
                              <br />
                            </div>
                          );
                        })}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Fee")}</>}</Translation>
                    </th>
                    <td>${chargable_fee}</td>
                  </tr>

                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Status")}</>}</Translation>
                    </th>

                    <td>
                      <Translation>
                        {(t) => <>{t(String(status))}</>}
                      </Translation>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("State")}</>}</Translation>
                    </th>
                    <td>
                      <Translation>
                        {(t) => <>{t(String(state))}</>}
                      </Translation>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Note")}</>}</Translation>
                    </th>
                    <td>{notes_external}</td>
                  </tr>
                  <tr>
                    <th>
                      <Translation>{(t) => <>{t("Image")}</>}</Translation>
                    </th>
                    <td>
                      {photos && photos.length
                        ? photos.map((e, key) => {
                            return (
                              <img
                                key={key}
                                style={{ marginBottom: 0, marginRight: 5 }}
                                src={e.photo}
                                alt=""
                                height="80"
                                width="80"
                                className="image-preview"
                                accept="image/png, image/jpeg"
                              />
                            );
                          })
                        : []}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
          </Modal>
          {show_alert && (
            <CustomContentAlert
              delay={4000}
              message={api_success_message}
              className="toast-success"
            />
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  TicketDetails,
}) => {
  const { timezone, property } = UserProfileDetails;
  const { userProfileDetails, backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  const { api_response, api_success_message } = APIResponseDetails;
  const { driverMessage, driverMessageList, ticketDetails, updateLanguage } =
    TicketDetails;
  return {
    property,
    timezone,
    api_response,
    driverMessage,
    driverMessageList,
    userProfileDetails,
    api_success_message,
    ticketDetails,
    main_body,
    updateLanguage,
  };
};

const mapStateToDispatch = {
  sendText: TicketActions.sendText,
  getMessageList: TicketActions.getMessageList,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  ticketDisputeStatusChange: TicketActions.statusChange,
  selectedLanguage: TicketActions.selectedLanguage,
};

export default connect(mapStateToProps, mapStateToDispatch)(Dispute);
